import { getCountry } from '../utils/dazn/Region';

let pageDiscountsEnabled: boolean;
let pageDiscountProductGroup: string;
let pageDiscountPromoCodes: Record<string, string>;
let multiPromoDiscountsEnabled: boolean;
let promoCodeList: string[];
let hermesOfferEnabled: boolean;
let hermesOfferEnabledForProductGroup: Record<string, string>;

const checkIfPageDiscountsEnabled = () => {
    if (pageDiscountsEnabled !== undefined) {
        return pageDiscountsEnabled;
    }

    try {
        pageDiscountsEnabled = window.dazn.features.isEnabledAnonymous(
            'f_ar_page_discounts'
        );

        return pageDiscountsEnabled;
    } catch (_err) {
        return false;
    }
};

const checkIfMultiPromoDiscountsEnabled = () => {
    if (multiPromoDiscountsEnabled !== undefined) {
        return multiPromoDiscountsEnabled;
    }

    try {
        multiPromoDiscountsEnabled = window.dazn.features.isEnabledAnonymous(
            'f_ar_mutli_landingpageids_combine_dicounts'
        );

        return multiPromoDiscountsEnabled;
    } catch (_err) {
        return false;
    }
};

const getPageDiscountsProductGroup = () => {
    if (pageDiscountProductGroup !== undefined) {
        return pageDiscountProductGroup;
    }

    try {
        pageDiscountProductGroup =
            window.dazn.features.getVariableStringAnonymous(
                'f_ar_page_discounts',
                'productGroup'
            ) ||
            window.dazn.features.getVariableStringAnonymous(
                'f_ar_mutli_landingpageids_combine_dicounts',
                'forProductGroup'
            );

        return pageDiscountProductGroup;
    } catch (_err) {
        return '';
    }
};

const getPromoCodeList = (): string[] => {
    if (promoCodeList) {
        return promoCodeList;
    }

    try {
        const promoCodesString =
            window.dazn.features.getVariableStringAnonymous(
                'f_ar_mutli_landingpageids_combine_dicounts',
                'multiPromoLandingPageIds'
            );

        const promoCodesArray = promoCodesString?.split(',') ?? [];

        promoCodeList =
            promoCodesArray.map((promoCode: string) => {
                const country = getCountry().toLowerCase();
                return promoCode.includes('{country}')
                    ? promoCode.replace('{country}', country).trim()
                    : promoCode.trim();
            }) ?? [];

        return promoCodeList;
    } catch (error) {
        return [];
    }
};

const getPageDiscountsPromoCodes = () => {
    if (pageDiscountPromoCodes !== undefined) {
        return pageDiscountPromoCodes;
    }

    try {
        const promoCodes = window.dazn.features.getVariableStringAnonymous(
            'f_ar_page_discounts',
            'pagePaths'
        );
        pageDiscountPromoCodes = JSON.parse(promoCodes as string);

        if (pageDiscountPromoCodes) {
            Object.keys(pageDiscountPromoCodes)?.forEach((key) => {
                const value = pageDiscountPromoCodes[key];
                const country = getCountry().toLowerCase();
                const promoValue = value?.replace('{country}', country);
                pageDiscountPromoCodes[key] = promoValue;
            });
        }

        return pageDiscountPromoCodes;
    } catch (_err) {
        return {};
    }
};

const checkIfHermesOfferEnabled = () => {
    if (hermesOfferEnabled !== undefined) {
        return hermesOfferEnabled;
    }
    try {
        hermesOfferEnabled =
            window.dazn.features.isEnabledAnonymous('f_ar_hermes_offers');

        return hermesOfferEnabled;
    } catch (_err) {
        return false;
    }
};

const checkIfHermesOfferEnabledPerProductGroup = (productGroup: string) => {
    if (hermesOfferEnabledForProductGroup !== undefined) {
        if (hermesOfferEnabledForProductGroup[productGroup]) {
            return true;
        }
    }
    try {
        const hermaOfferProductGroup =
            window.dazn.features.getVariableStringAnonymous(
                'f_ar_hermes_offers',
                'enabledPerProduct'
            ) || '';

        hermesOfferEnabledForProductGroup = JSON.parse(hermaOfferProductGroup);

        if (hermesOfferEnabledForProductGroup[productGroup]) {
            return true;
        }
    } catch (_err) {
        return false;
    }
};

export {
    checkIfMultiPromoDiscountsEnabled,
    checkIfPageDiscountsEnabled,
    getPageDiscountsProductGroup,
    getPageDiscountsPromoCodes,
    getPromoCodeList,
    checkIfHermesOfferEnabled,
    checkIfHermesOfferEnabledPerProductGroup
};
